import { render } from "./SearchProviderResults.vue?vue&type=template&id=15cf55c1&scoped=true"
import script from "./SearchProviderResults.vue?vue&type=script&lang=js"
export * from "./SearchProviderResults.vue?vue&type=script&lang=js"

import "./SearchProviderResults.vue?vue&type=style&index=0&id=15cf55c1&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15cf55c1"]])

export default __exports__